// Design System v2 — Premium Modern Theme
// Surface hierarchy: bg (deepest) → sf (surface) → cd (card) → el (elevated)
// Text hierarchy: tx (primary) → ts (secondary text) → tt (tertiary/muted)
const themes = {
    dark: {
        bg: "#0a0a0c",       // Deep rich black (not pure)
        sf: "#111114",       // Surface layer
        cd: "#1a1a1f",       // Card
        el: "#222228",       // Elevated surface
        tx: "#f5f5f7",       // Primary text (soft white)
        ts: "#a1a1aa",       // Secondary text
        tt: "#63636e",       // Tertiary/muted text
        sc: "#8e8e93",       // Secondary (kept for compat)
        ac: "#3b82f6",       // Primary accent — modern blue
        a2: "#2563eb",       // Accent darker (hover)
        gn: "#22c55e",       // Green — success
        bd: "rgba(255,255,255,0.08)", // Subtle border
        b2: "rgba(255,255,255,0.12)", // Stronger border
        rd: "#ef4444",       // Red — error
        wn: "#f59e0b",       // Warning amber
        ib: "rgba(255,255,255,0.06)", // Input bg
        pp: "#a855f7",       // Purple
        gl: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)", // Primary gradient
        sh: "0 1px 2px rgba(0,0,0,0.3), 0 4px 12px rgba(0,0,0,0.2)",  // Card shadow
        s2: "0 4px 24px rgba(0,0,0,0.4), 0 1px 4px rgba(0,0,0,0.3)",  // Elevated shadow
        s3: "0 8px 40px rgba(0,0,0,0.5)",  // Modal shadow
        ov: "rgba(0,0,0,0.6)" // Overlay
    },
    light: {
        bg: "#f4f4f8",       // Cool light gray
        sf: "#eeeef2",       // Surface layer
        cd: "#ffffff",       // Card
        el: "#ffffff",       // Elevated surface
        tx: "#111114",       // Primary text
        ts: "#64648c",       // Secondary text
        tt: "#9494a8",       // Tertiary/muted text
        sc: "#8e8e93",       // Secondary (kept for compat)
        ac: "#3b82f6",       // Primary accent
        a2: "#2563eb",       // Accent darker (hover)
        gn: "#16a34a",       // Green — success
        bd: "rgba(0,0,0,0.06)", // Subtle border
        b2: "rgba(0,0,0,0.1)",  // Stronger border
        rd: "#ef4444",       // Red — error
        wn: "#d97706",       // Warning amber
        ib: "rgba(0,0,0,0.04)", // Input bg
        pp: "#9333ea",       // Purple
        gl: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)", // Primary gradient
        sh: "0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03)", // Card shadow
        s2: "0 4px 24px rgba(0,0,0,0.06), 0 1px 4px rgba(0,0,0,0.04)", // Elevated shadow
        s3: "0 8px 40px rgba(0,0,0,0.1)",  // Modal shadow
        ov: "rgba(0,0,0,0.4)" // Overlay
    }
};

export default themes;
